// ---------------------------------------------------------------------------
// Diff da edição do pedido (fase 2 da refatoração visual, 2026-09-10).
//
// A lista enviada no PUT substitui INTEGRALMENTE o pedido — então o "salvar"
// passa por um modal de revisão (decisão F3) que mostra o que de fato muda:
// quantidades alteradas, itens incluídos e itens removidos, com deltas.
//
// `predictsOrderClose` antecipa o aviso "a redução encerra a ordem ao salvar".
// ⚠️ É PREVISÃO de UI — a autoridade é o `status_transition` da resposta.
// E a previsão segue o CONTRATO, não o protótipo: a ordem só fecha quando a
// contagem satisfaz (pedido = expedido = conferido + tratado). Reduzir o
// pedido ao expedido com remessa ainda EM TRÂNSITO não fecha nada — falta a
// conferência. O protótipo ignorava isso (qty ≤ expedido bastava) e prometeria
// um fechamento que o servidor não faria.
// ---------------------------------------------------------------------------

function num(value) {
   const parsed = Number(value);
   return Number.isFinite(parsed) ? parsed : 0;
}

// originalItems: itens da ordem carregada (com acumuladores do backend).
// currentItems: estado do editor (prod_id, prod_sku, prod_name, requested_qtd).
export function buildEditDiff(originalItems = [], currentItems = []) {
   const origById = new Map(
      originalItems.map((item) => [String(item.prod_id), item])
   );
   const currIds = new Set(currentItems.map((item) => String(item.prod_id)));

   const changed = [];
   const added = [];
   const removed = [];

   currentItems.forEach((item) => {
      const orig = origById.get(String(item.prod_id));
      const to = num(item.requested_qtd);
      const base = {
         prodId: item.prod_id,
         sku: item.prod_sku ?? null,
         name: item.prod_name ?? null,
      };

      if (!orig) {
         added.push({ ...base, from: null, to, delta: to });
         return;
      }

      const from = num(orig.requested_qtd);
      if (to !== from) {
         changed.push({ ...base, from, to, delta: to - from });
      }
   });

   originalItems.forEach((orig) => {
      if (currIds.has(String(orig.prod_id))) return;
      const from = num(orig.requested_qtd);
      removed.push({
         prodId: orig.prod_id,
         sku: orig.prod_sku ?? null,
         name: orig.prod_name ?? null,
         from,
         to: null,
         delta: -from,
      });
   });

   return {
      changed,
      added,
      removed,
      total: changed.length + added.length + removed.length,
   };
}

// A edição fecha a ordem quando, PARA TODO item da lista nova:
//   · a quantidade cai para o já expedido (o piso — abaixo disso é 422); e
//   · o expedido já foi todo conferido/tratado (nada em trânsito).
// Item incluído nunca satisfaz (expedido = 0 < quantidade mínima 1).
export function predictsOrderClose(currentItems = [], originalItems = [], diffTotal = 0) {
   if (diffTotal <= 0 || currentItems.length === 0) return false;

   const origById = new Map(
      originalItems.map((item) => [String(item.prod_id), item])
   );

   let anyShipped = false;

   const everyItemSatisfied = currentItems.every((item) => {
      const orig = origById.get(String(item.prod_id));
      if (!orig) return false; // item novo reabre saldo a expedir

      const shipped = num(orig.shipped_qtd);
      const counted = num(orig.received_qtd) + num(orig.settled_qtd);
      if (shipped > 0) anyShipped = true;

      return num(item.requested_qtd) === shipped && counted === shipped;
   });

   return everyItemSatisfied && anyShipped;
}
